import { Link } from 'component/Link'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import Logo from './logo.svg'

export const Powered = observer(() => {
  const { footer, basic } = useDemo()
  const { powered, by, url } = footer
  const logo = by === 'DRESSCODE AI'
  const label = logo ? <Logo /> : by

  return <Space gap={8} height={56} center>
    <Typo size={13} semi tertiary>
      {powered}
    </Typo>
    <Typo size={13} semi>
      {basic ? label : <Link href={url}>
        {label}
      </Link>}
    </Typo>
  </Space>
})
